import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';

/** Must match the string literal src/sw-push.js posts on notificationclick. */
export const PUSH_DEEP_LINK_MESSAGE = 'push-deeplink';

/**
 * Routes the app to the record a push notification pointed at.
 *
 * src/sw-push.js posts `{ type: 'push-deeplink', deepLink }` to an existing window when a
 * notification is tapped, instead of navigating the tab itself -- that keeps whatever the open
 * tab was doing intact. This service is the other half: it listens for that message and drives
 * the Angular router.
 */
@Injectable({ providedIn: 'root' })
export class PushDeepLinkService {
  constructor(
    private router: Router,
    private zone: NgZone,
  ) {}

  /** Called once from AppComponent, next to PushNotificationService.init(). */
  listen(): void {
    if (!('serviceWorker' in navigator)) {
      return;
    }
    navigator.serviceWorker.addEventListener('message', (event) => {
      const data = event.data as { type?: string; deepLink?: string } | null;
      if (!data || data.type !== PUSH_DEEP_LINK_MESSAGE || !data.deepLink) {
        return;
      }
      // navigator.serviceWorker message events are NOT zone-patched, so a bare navigate here
      // would update the router without scheduling change detection and the view would not
      // repaint. Same trap AuthSyncService and UserSettingStore document for BroadcastChannel.
      const deepLink = data.deepLink;
      this.zone.run(() => void this.router.navigateByUrl(deepLink));
    });
  }
}
